module.exports = __webpack_public_path__ + "static/media/heic-heif-file-type.9400e869.svg";